export const MAIN_COLOR = '#4696e5';

export const MAIN_COLOR_ALPHA = 'rgba(70, 150, 229, 0.4)';

export const HIGHLIGHTED_COLOR = '#F77F28';

export const HIGHLIGHTED_COLOR_ALPHA = 'rgba(247, 127, 40, 0.4)';
